export default __webpack_public_path__ + "static/media/blog_dubai-to-canada.8bd6825a.png";